<div class="page-not-found">
  <div class="page-not-found__404">404</div>
  <div class="page-not-found__header">Page not found!</div>
  <div class="page-not-found__info">
    Oops! The page you are looking for doesnt exist. It might have been moved or delete.
  </div>
  <button class="basic-btn basic-btn_teal" routerLink="/">Go to Home</button>
</div>
